import React, { useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Logo from './assets/images/okularlogin.svg';
import axios from 'axios';
import { BASE_URL_TRUSTNET } from './api';
import { CircularProgress } from '@material-ui/core';
import { Strings } from './Strings';

function Copyright() {
  const classes = useStyles();
  return (
    <div style={{ marginBottom: 10 }}>
      <div className={classes.common_link}>
        <Typography variant='p' color='textSecondary' align='center'>
          <Link
            className={classes.link}
            color='inherit'
            href={process.env.REACT_APP_TERMS_AND_CONDITIONS}
          >
            {Strings.TERMS_AND_CONDITIONS}
          </Link>
          <Link
            className={classes.link}
            color='inherit'
            href={process.env.REACT_APP_PRIVACY_POLICY}
          >
            {Strings.PRIVACY_POLICY}
          </Link>
        </Typography>
      </div>
      <div className={classes.common_link}>
        <Typography variant='p' color='textSecondary' align='center'>
          {Strings.COPYRIGHTS_TEXT}
        </Typography>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    // marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  passloq_logo: {
    width: 185,
    marginBottom: 30,
    marginTop: 60,
  },
  link: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  common_link: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: 'small',
  },
  message: {
    marginTop: 50,
    textAlign: 'center',
  },
}));

function Logout(props) {
  const classes = useStyles();
  const [success, setSuccess] = React.useState(false);

  useEffect(async () => {
    // const data = 'https://passloq.aikaki.com/logout/?openid=true';
    const isOpenId = new URL(window.location.href).searchParams.get('openid');
    const sub_sid = sessionStorage.getItem('sub_sid');
    if (isOpenId) {
      const data = {
        sub_sid,
      };

      const headers = {
        'Content-Type': 'application/json',
        'Authorization':
          'Bearer 2YLsSewUesHz9rsWTuE0kpYTMoIL027m-IsbR5uaCC-jG-mP',
      };

      let res = await axios.post(
        `https://aikakitest.c2id.net/logout-sessions/rest/v1`,
        data,
        { headers: headers }
      );

      if (res.data.sid || res.data.type !== 'end') {
        const data1 = {
          confirm_logout: true,
          sid: res.data.sid,
        };
        let res1 = await axios.put(
          `${BASE_URL_TRUSTNET}/PostLogoutSession`,
          data1
        );
        if (res1.data.success) {
          setSuccess(true);
          sessionStorage.removeItem('sub_sid');
        }
      }
    } else {
      setSuccess(true);
    }
    return () => {};
  }, []);

  return (
    <Container component='main' maxWidth='sm'>
      <CssBaseline />
      <div className={classes.paper}>
        <img
          src={Logo}
          alt={Strings.LOGO_TEXT}
          className={classes.passloq_logo}
        />
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        {success ? (
          <Typography className={classes.message} component='h1' variant='h5'>
            {Strings.SUCCESSFULLY_LOGOUT}
          </Typography>
        ) : (
          <CircularProgress
            size='25px'
            style={{ marginTop: '35px', color: '#DF3359' }}
          />
        )}
        <div style={{ marginTop: 'auto' }}>
          <Copyright />
        </div>
      </div>
    </Container>
  );
}

export default Logout;
